export type ControlsEvent =
	| 'view'
	| 'navigation'
	| 'menu'
	| 'command'
	| 'input'
	| 'send'
	| 'voice'
	| 'solution';
export type ControlsDetails = {
	action?: string;
	source?: 'button' | 'slash' | 'keyboard';
	stage?: 'intent' | 'success' | 'error' | 'cancel';
	reason?: 'network' | 'request' | 'unavailable' | 'microphone';
};
export type ControlsTrack = (
	event: ControlsEvent,
	details?: ControlsDetails,
) => void;
export function createControlsTracker(
	reachGoal: (goal: string, parameters: Record<string, unknown>) => unknown,
	context: {
		mode: string;
		problemId?: string;
		entryPoint?: 'course' | 'roadmap' | 'standalone' | 'candidate' | 'gate';
	},
): ControlsTrack {
	return (event, details = {}) => {
		const parameters: Record<string, unknown> = { mode: context.mode };
		if (context.problemId) parameters.problemId = context.problemId;
		if (context.entryPoint) parameters.entryPoint = context.entryPoint;
		for (const key of ['action', 'source', 'stage', 'reason'] as const)
			if (details[key] !== undefined) parameters[key] = details[key];
		try {
			const goal =
				event === 'view'
					? 'ai_dialog_controls_view'
					: event === 'input'
						? 'ai_dialog_input_engaged'
						: event === 'menu'
							? `ai_dialog_menu_${details.action === 'close' ? 'close' : 'open'}`
							: `ai_dialog_${event}`;
			const result = reachGoal(goal, {
				ai_dialog_controls: parameters,
			});
			if (result instanceof Promise) void result.catch(() => {});
		} catch {
			/* Analytics cannot interrupt the dialogue. */
		}
	};
}
